import { FC } from "react"
import React,{useEffect, useState, useMemo } from "react";
import { useIntl } from "react-intl"
import { PageTitle } from "../../../smallnation/layout/core"
import { KTSVG } from "../../../smallnation/helpers"
import services from "../../modules/services/services"
import { Pagination } from "../../modules/utility/Pagination"
import moment from "moment";
//import { TablesWidget10, TablesWidget5,TablesWidget1, TablesWidget2,TablesWidget3,TablesWidget4,TablesWidget6,TablesWidget7,TablesWidget8,TablesWidget9,TablesWidget11,TablesWidget12,TablesWidget13  } from "../../../smallnation/partials/widgets"
//import { ProfileDirectoryInc } from "../../../smallnation/partials/widgets/tables/profileDirectoryInc"


const ProfileEdit: FC = () => {
      const intl = useIntl()

      const [currentPage, setCurrentPage] = useState(1);
      const ITEMS_PER_PAGE = 10; // Per page show the data pagination
      const Pagesize=10;

      const [totalItems, setTotalItems] = useState(0);
      const [totalpages, settotalPages] = useState(0);
      const [adminProfileList, setAdminProfileList] = useState([]);

      const handlePageChange2 = (offset,triggerevent) => {
        // alert(offset);
        getAdminProfilesList(ITEMS_PER_PAGE,offset,'','');
      };
      function getAdminProfilesList(ITEMS_PER_PAGE,pageNumber,sortBy,sortDir){   

            const requestObject={
         
              "status":"published",
              "pageNumber":pageNumber,
              "sortyBy":"updatedDate",
              "pageSize":ITEMS_PER_PAGE,
              "siteId":"2",
              "sortDir":"asc"
            }
         console.log(requestObject);
         var accessTokenIn=sessionStorage.getItem("adminAccToken");
        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json',
                   // 'Authorization': "Bearer "+accessTokenIn 
                    //'Authorization': accessTokenIn 
                  },
          body: JSON.stringify(requestObject)
        };
        
        services.getAdminProfileList(requestOptions).then((res) => 
        {
            console.log("#######################");
            if(res){
              console.log(JSON.stringify(res));
              setTotalItems(res.totalElements);         
              settotalPages(Math.ceil(res.totalElements / ITEMS_PER_PAGE));            
              setCurrentPage(pageNumber);
              setAdminProfileList(res.content);  
            }
              
        
        });



            
        }

      useEffect(() => 
      {         
        getAdminProfilesList(ITEMS_PER_PAGE,'1','','');       

      },[]);
      type Props = {
        className: string
      }
      return (
        <>
          <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'Published Profiles'})}</PageTitle>
         
          
        <div className={`card`}>
     
      {/* begin::Body */}
      <div className='card-body py-3'>
        {/* begin::Table container */}
        <div className='table-responsive'>
          {/* begin::Table */}
          <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3'>
            {/* begin::Table head */}
            <thead>
              <tr className='fw-bolder text-muted'>
                <th className='w-25px'>
                  <div className='form-check form-check-sm form-check-custom form-check-solid'>
                    <input
                      className='form-check-input'
                      type='checkbox'
                      value='1'
                      data-kt-check='true'
                      data-kt-check-target='.widget-13-check'
                    />
                  </div>
                </th>
                <th className='min-w-150px'>ID</th>
                <th className='min-w-140px'>Updated</th>
                <th className='min-w-120px'>Name</th>
               
               
                <th className='min-w-120px'>Status</th>
                <th className='min-w-100px text-end'>Actions</th>
              </tr>
            </thead>
            {/* end::Table head */}
            {/* begin::Table body */}
            <tbody>

            {	
	          adminProfileList.map((data, index) => (
              <tr>
                <td>
                  <div className='form-check form-check-sm form-check-custom form-check-solid'>
                    <input className='form-check-input widget-13-check' type='checkbox' value='1' />
                  </div>
                </td>
                <td>
                  <a href='#' className='text-dark fw-bolder text-hover-primary fs-6'>
                    {data.profileId}
                  </a>
                </td>
                <td>
                  <a href='#' className='text-dark fw-bolder text-hover-primary d-block mb-1 fs-6'>
               
                  {moment(data.updatedOn).format("MM/DD/YYYY")}
                  </a>
                 
                </td>
                <td>
                  <a href='#' className='text-dark fw-bolder text-hover-primary d-block mb-1 fs-6'>
                  {data.name}
                  </a>
                 
                </td>
              
            
                <td>
                  <span className='badge badge-light-success'> {data.status}</span>
                </td>
                <td className='text-end'>
                  {/* <a
                    href='#'
                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                  >
                    <KTSVG path='/media/icons/duotune/general/gen019.svg' className='svg-icon-3' />
                  </a> */}
                  <a
                    href='#'
                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                  >
                    <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-3' />
                  </a>
                  {/* <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                    <KTSVG path='/media/icons/duotune/general/gen027.svg' className='svg-icon-3' />
                  </a> */}
                </td>
              </tr>
              ))}
              
            </tbody>
            {/* end::Table body */}
          </table>


          <Pagination
                
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={handlePageChange2}

                />
          {/* end::Table */}
        </div>
        {/* end::Table container */}
      </div>
      {/* begin::Body */}
    </div>


          
        </>
      )
    }
export {ProfileEdit}